import { Link } from 'react-router-dom';

function SideNav() {
  return (
    <div className="md:col-span-1">
      <div className="py-3 border-b-[1px] ">
        <h2>Browse policies</h2>
      </div>
      <nav aria-label="Sidebar navigation">
        <ul>
          <li className="my-4 text-[#1668E3] hover:underline ">
            <Link to={'#'}>Privacy Policy</Link>
          </li>
          {/* <li className="my-4 text-[#1668E3] hover:underline ">
            <Link to={'#'}>Legal</Link>
          </li> */}
          {/* <li className="my-4 text-[#1668E3] hover:underline ">
            <Link to={'#'}>Press</Link>
          </li> */}
          <li className="my-4 text-[#1668E3] hover:underline ">
            <Link to="/marketplace-guidelines">Marketplace guidelines</Link>
          </li>
          <li className="my-4 text-[#1668E3] hover:underline ">
            <Link to={'#'}>Renting terms & conditions</Link>
          </li>
          <li className="my-4 text-[#1668E3] hover:underline ">
            <Link to="https://help.smallsmall.com/smallsmall/directories">
              FAQ
            </Link>
          </li>
          <li className="my-4 text-[#1668E3] hover:underline ">
            <Link to="https://help.smallsmall.com/smallsmall/directories">
              Knowledge base
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default SideNav;
